export const isValidQueryInput = (input?: string): input is string =>
	typeof input === 'string' && input.trim() !== '';

export const isValidUncontrolledInput = (input: string) =>
	isValidQueryInput(input) && input !== '"' && input !== '""';
